import { render, staticRenderFns } from "./digitalResources.vue?vue&type=template&id=567b8398&"
import script from "./digitalResources.vue?vue&type=script&lang=js&"
export * from "./digitalResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports